export default __webpack_public_path__ + "static/media/pg-51.b68d6853.jpg";